import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
// libs
import jwt from 'jsonwebtoken';
import isEmpty from 'lodash/isEmpty';
import { fromUnixTime } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import { mapState } from 'vuex';

// services
import { RequestService, ChatService } from '@/services';

// components
import ChatThread from '@corefront/components-v2/Chat/ChatThread';
import ComposerEditor from '@corefront/components-v2/Composer/ComposerEditor.vue';
import { CorefrontChatBubble } from '@/components';

// mixins
import { chatThread } from '@corefront/mixins-v2/chatThread';

// utils
import socket from '@corefront/utils/socket';

// constants
// import { COMMUNICATION_ROLE, MESSAGE_SEND_STATUS } from '@corefront/constant/messages';
import { MESSAGE_COMMUNICATION_ROLE as COMMUNICATION_ROLE, MESSAGE_SEND_STATUS } from '@/constants/message';
import { TOOLS } from '@corefront/constant/composer';
import { EVENTS } from '@corefront/constant/socket';
// import { now } from '@corefront/utils/now'
import { now } from '@/utils/now';
export default {
  components: {
    ChatThread,
    ComposerEditor,
    CorefrontChatBubble
  },
  mixins: [chatThread],
  props: {
    patientId: {
      type: String,
      required: true
    },
    forwardedMessageId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      reply: '',
      isFetchingData: false,
      forwardedRequest: null,
      adminPatientConversation: null,
      isReplying: false
    };
  },
  computed: {
    ...mapState('auth', ['currentUser']),
    MESSAGE_SEND_STATUS: () => MESSAGE_SEND_STATUS,
    TOOLS: () => TOOLS,
    profileUrlHashmaps() {
      var _this$forwardedReques, _this$forwardedReques2;
      return (_this$forwardedReques = (_this$forwardedReques2 = this.forwardedRequest) === null || _this$forwardedReques2 === void 0 ? void 0 : _this$forwardedReques2.messagelist.reduce((acc, curr) => {
        if (!curr.profileUrl) {
          return acc;
        }
        return {
          ...acc,
          [curr.userid]: curr.profileUrl
        };
      }, {})) !== null && _this$forwardedReques !== void 0 ? _this$forwardedReques : {};
    },
    namesHashmap() {
      var _this$forwardedReques3, _this$forwardedReques4;
      return (_this$forwardedReques3 = (_this$forwardedReques4 = this.forwardedRequest) === null || _this$forwardedReques4 === void 0 ? void 0 : _this$forwardedReques4.messagelist.reduce((acc, curr) => {
        if (!curr.firstname || !curr.lastname) {
          return acc;
        }
        return {
          ...acc,
          [curr.userid]: `${curr.firstname} ${curr.lastname}`
        };
      }, {})) !== null && _this$forwardedReques3 !== void 0 ? _this$forwardedReques3 : {};
    }
  },
  watch: {
    async showDialog(show) {
      if (show) {
        await this.refreshData();
      } else {
        this.forwardedRequest = null;
      }
    }
  },
  methods: {
    async sendReply() {
      try {
        if (this.isReplying) {
          return;
        }
        this.isReplying = true;
        const message = {
          id: uuidv4(),
          conversationId: this.adminPatientConversation.id,
          message: this.reply,
          attachment: [{
            type: 'forwarded_message_reply',
            forwardedMessageId: this.forwardedMessageId
          }]
        };
        await socket.ctx.emitWithAck(EVENTS.ADMIN_MESSAGE_NEW_MESSAGE, message);
        this.forwardedRequest.messagelist.push({
          messageversion: 'V2',
          readby: [],
          readbydetails: [],
          type: 'text',
          attachment: [],
          id: message.id,
          profileUrl: '',
          sentat: now(),
          message: message.message,
          conversationid: message.conversationId,
          userid: this.currentUser.id,
          firstname: this.currentUser.firstname,
          lastname: this.currentUser.lastname
        });
        this.reply = '';
        this.$_chatThread_scrollToBottom();
        this.$emit('reply');
        await RequestService.openForwardToChat(this.patientId, this.forwardedMessageId);
      } finally {
        this.isReplying = false;
      }
    },
    chatThreadDateResolver(msg) {
      return fromUnixTime(msg.sentat);
    },
    getCommunicationRole(msg) {
      var _this$forwardedReques5;
      return msg.userid === ((_this$forwardedReques5 = this.forwardedRequest) === null || _this$forwardedReques5 === void 0 ? void 0 : _this$forwardedReques5.patientid) ? COMMUNICATION_ROLE.RECEIVER : COMMUNICATION_ROLE.SENDER;
    },
    getBubbleBackgroundClass(msg) {
      const role = this.getCommunicationRole(msg);
      return role === COMMUNICATION_ROLE.RECEIVER ? 'tw-bg-secondary-light' : 'tw-bg-warm-gray';
    },
    async refreshData() {
      try {
        this.isFetchingData = true;
        const [{
          data: forwardedRequest
        }, {
          data: adminPatientConversation
        }] = await Promise.all([this.forwardedRequest ? Promise.resolve(null) : RequestService.getForwardedRequest(this.patientId, this.forwardedMessageId), this.adminPatientConversationId ? Promise.resolve(null) : ChatService.listSingleConversation(this.patientId)]);
        if (!isEmpty(forwardedRequest)) {
          this.forwardedRequest = forwardedRequest;
        }
        if (!isEmpty(adminPatientConversation)) {
          this.adminPatientConversation = adminPatientConversation;
        }
        await this.$nextTick();
        await this.$_chatThread_scrollToBottom();
      } catch (err) {
        console.error(err);
      } finally {
        this.isFetchingData = false;
      }
    },
    close() {
      this.showDialog = false;
      this.$emit('close');
    },
    getDate(date) {
      if (date == '-') {
        return '-';
      }
      return new Date(date * 1000).toDateString();
    },
    redirectToIntercom(id) {
      // ! ONLY WORKS ON PROD
      const token = jwt.sign({}, 'NTNv7j0TuYARvmNMmWXo6fKvM4o6nv/aUi9ryX38ZH+L1bkrnD1ObOQ8JAUmHCBq7Iy7otZcyAagBLHVKvvYaIpmMuxmARQ97jUVG16Jkpkp1wXOPsrF9zwew6TpczyHkHgX5EuLg2MeBuiT/qJACs1J0apruOOJCg/gOtkjB4c=', {
        header: {
          predicates: [{
            attribute: 'role',
            comparison: 'eq',
            type: 'role',
            value: 'user_role'
          }, {
            attribute: 'user_id',
            comparison: 'eq',
            type: 'string',
            value: id
          }]
        }
      });
      const toSubmit = token.split('.');
      window.open(`https://app.intercom.com/a/apps/dfvodm6i/users/segments/all-users:${toSubmit[0]}`, '_blank');
    }
  }
};